// extracted by mini-css-extract-plugin
export default {"component":"styles__component--w246v","box":"styles__box--qP5fE","reveal":"styles__reveal--DDSQv","tip":"styles__tip--nOnpc","showBoxes":"styles__showBoxes--hdqLz"};